import { useQuery, useInfiniteQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'
import { Organization } from 'interfaces/organization'
import { PaginatedData } from 'interfaces/paginated-data'

const fetchOrganizationsMissingInfo = async (
  page: number = 1,
  perPage: number = 100
) => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/missing_info?page=${page}&per_page=${perPage}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json: {
    data: {
      organizations: Organization[]
    } & PaginatedData
  } = await response.json()
  return json.data
}

const useOrganizationsMissingInfo = () => {
  return useInfiniteQuery(
    [organizationsKeys.all, 'missing-info'],
    ({ pageParam = 1 }) => fetchOrganizationsMissingInfo(pageParam, 100),
    {
      refetchOnWindowFocus: false,
      staleTime: 300000,
      cacheTime: 600000,
      retry: 2,
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length
        const totalPages = parseInt(lastPage.number_of_pages || '0', 10)
        return currentPage < totalPages ? currentPage + 1 : undefined
      },
    }
  )
}

export default useOrganizationsMissingInfo
